import { put, takeEvery } from "redux-saga/effects";
import { ITreeviewChuongTrinhDaoTaoFocusedValue } from "../../../components-data/treeview-ctdt/TreeviewChuongTrinhDaoTao";
import {
    eChuongTrinhDaoTaoSoSanhActionIds,
    eChuongTrinhDaoTaoSoSanhTab,
    IChuongTrinhDaoTaoSoSanhActionTypes,
} from "../../action-types/ctdt/IChuongTrinhDaoTaoSoSanhActionTypes";
import { rootActions } from "../../actions/rootActions";

export function* chuongTrinhDaoTaoSoSanhSaga(): any {
    yield takeEvery(eChuongTrinhDaoTaoSoSanhActionIds.INI_START, iniWorker);
    yield takeEvery(eChuongTrinhDaoTaoSoSanhActionIds.CHANGE_FOCUSED_TAB_START, changeFocusedTabWorker);
    yield takeEvery(eChuongTrinhDaoTaoSoSanhActionIds.CHANGE_CHUONG_TRINH_GOC_START, changeChuongTrinhGocWorker);
    yield takeEvery(eChuongTrinhDaoTaoSoSanhActionIds.CHANGE_CHUONG_TRINH_SO_SANH_START, changeChuongTrinhSoSanhWorker);
}

function* iniWorker(): any {
    yield put(rootActions.chuongTrinhDaoTaoWrapper.soSanh.INI_SUCCESS(undefined));
}

function* changeFocusedTabWorker(action: IChuongTrinhDaoTaoSoSanhActionTypes): any {
    yield put(rootActions.chuongTrinhDaoTaoWrapper.soSanh.CHANGE_FOCUSED_TAB_SUCCESS(action.payload as eChuongTrinhDaoTaoSoSanhTab));
}

function* changeChuongTrinhGocWorker(action: IChuongTrinhDaoTaoSoSanhActionTypes): any {
    yield put(
        rootActions.chuongTrinhDaoTaoWrapper.soSanh.CHANGE_CHUONG_TRINH_GOC_SUCCESS(
            action.payload as ITreeviewChuongTrinhDaoTaoFocusedValue | undefined
        )
    );
}

function* changeChuongTrinhSoSanhWorker(action: IChuongTrinhDaoTaoSoSanhActionTypes): any {
    yield put(
        rootActions.chuongTrinhDaoTaoWrapper.soSanh.CHANGE_CHUONG_TRINH_SO_SANH_SUCCESS(
            action.payload as ITreeviewChuongTrinhDaoTaoFocusedValue | undefined
        )
    );
}
